import Firebase from './Firebase';

export default new Firebase();
